import { Button } from '@mui/material';
import SiteModel from '../../models/layout.model';
import MenuModel from '../../models/menu.model';
import './home.page.scss';
import { NavLink, useLocation } from 'react-router-dom';
import { CONSTANTS } from '../../constants/constants';
import SessaoComponent from '../../components/sessao/sessao.component';
import React, { useEffect } from 'react';
import CarrosselComponent from '../../components/carrossel/carrossel.component';
import ContatoComponent from '../../components/contato/contato.component';
import GaleriaComponent from '../../components/galeria/galeria.component';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import AcessoPage from '../acesso/acesso.page';

export type HomeComponentProps = {
  site?: SiteModel;
  menu?: MenuModel;
  menuID?: string;
  idDoComponente?: string;
  title: string;
}

export default function HomePage(props: HomeComponentProps) {

  const location = useLocation();

  useEffect(() => {
    document.title = props.title;
    const itemMenu: any = props.menu?.itens.find(x => x.id_do_componente === props.menuID);
    if (itemMenu) {
      document.querySelector('meta[name="description"]')?.setAttribute("content", itemMenu.descricao);
      document.querySelector('meta[name="keywords"]')?.setAttribute("content", itemMenu.palavras_chave);
    }

  }, [location])

  return (
    <>
      {
        props.menu?.tipo_menu === CONSTANTS.TIPO_MENU.SCROLL ?
          <>
            {
              props.site?.components?.map((itemSite, iSite) => (
                <React.Fragment key={iSite}>
                  {
                    itemSite.tipo === CONSTANTS.TIPO_COMPONENTE.SESSAO &&
                    <SessaoComponent menu={props.menu} itemSite={itemSite} />
                  }
                  {
                    itemSite.tipo === CONSTANTS.TIPO_COMPONENTE.CARROSSEL &&
                    <CarrosselComponent isScroll={true} carrossel={itemSite.carrossel} ID={itemSite.id} />
                  }
                  {
                    itemSite.tipo === CONSTANTS.TIPO_COMPONENTE.CONTATO &&
                    <ContatoComponent menu={props.menu} itemSite={itemSite} />
                  }
                  {
                    itemSite.tipo === CONSTANTS.TIPO_COMPONENTE.GALERIA &&
                    <GaleriaComponent galeria={itemSite.galeria} itemSite={itemSite} />
                  }
                </React.Fragment>
              ))
            }
          </>
          :
          <>
            {
              props.site?.components?.map((itemSite, iSite) => (
                <React.Fragment key={iSite}>
                  {
                    (itemSite.tipo === CONSTANTS.TIPO_COMPONENTE.SESSAO && (itemSite.sessao ? itemSite.sessao.id.split(',').indexOf(props.menuID ? props.menuID : '') >= 0 : true)) &&
                    <SessaoComponent menu={props.menu} itemSite={itemSite} />
                  }
                  {
                    (itemSite.tipo === CONSTANTS.TIPO_COMPONENTE.CARROSSEL && (itemSite.carrossel ? itemSite.carrossel.id.split(',').indexOf(props.menuID ? props.menuID : '') >= 0 : true)) &&
                    <CarrosselComponent carrossel={itemSite.carrossel} ID={itemSite.id} />
                  }
                  {
                    (itemSite.tipo === CONSTANTS.TIPO_COMPONENTE.CONTATO && (itemSite.contato ? itemSite.contato.id.split(',').indexOf(props.menuID ? props.menuID : '') >= 0 : true)) &&
                    <ContatoComponent menu={props.menu} itemSite={itemSite} />
                  }
                  {
                    (itemSite.tipo === CONSTANTS.TIPO_COMPONENTE.GALERIA && (itemSite.galeria ? itemSite.galeria.id.split(',').indexOf(props.menuID ? props.menuID : '') >= 0 : true)) &&
                    <GaleriaComponent galeria={itemSite.galeria} itemSite={itemSite} />
                  }
                </React.Fragment>
              ))
            }
            {
              props.idDoComponente === 'area-cliente-a7apps' &&
              <AcessoPage site={props.site} />
            }
          </>
      }
      {
        props.site?.whatsapp?.celular &&
        <Button className='bt-whatsapp' href={`https://api.whatsapp.com/send?phone=${props.site.whatsapp.celular}&text=${props.site.whatsapp.texto}`} target='_blank'>
          <WhatsAppIcon />
        </Button>
      }
    </>
  );
}